import Vue from 'vue';

Vue.filter('truncateCustom', function (v, arg) {
    if(!v) return '';
    return v.substring(0, arg) + '...';
});